// src/Components/EmojiPicker.index.tsx
import OverlayWindow from 'Components/OverlayWindow';
import { useCreatePopup } from 'Components/Popups';
import { Emojis } from './data';
import EmojiPreview from './EmojiPreview';
import EmojisListContainer from './EmojisListContainer';
import PreviewEmojiContextProvider from './PreviewEmojiContext';
import SelectEmojiProvider from './SelectEmojiProvider';

type EmojiMartDataType = typeof Emojis;
export type EmojiName = keyof EmojiMartDataType['emojis'];

export type EmojiData = (typeof Emojis.emojis)['+1'];
export interface IEmojiPreviewRef {
  setPreview: (emoji?: EmojiData) => void;
}

export default function EmojiPicker({
  onChange,
}: {
  onChange: (emoji: string) => void;
}) {
  const Popup = useCreatePopup();

  return (
    <div className="relative inline-block">
      {/* Trigger Button */}
      <button
        ref={Popup.setAnchor}
        onClick={Popup.toggle}
        className="
          relative group
          flex items-center justify-center
          w-9 h-9
          rounded-full
          bg-white
          border border-gray-300
          text-gray-500
          hover:bg-gray-100
          hover:text-gray-700
          transition-colors
        "
      >
        {/* If you have a dedicated emoji icon, use it here. Otherwise, just text. */}
        <span className="text-md font-semibold">😊</span>

        {/* Tooltip (optional) */}
        <span
          className="
          absolute bottom-full left-1/2
          -translate-x-1/2 mb-1
          px-2 py-1
          bg-gray-700 text-white text-xs
          rounded
          opacity-0 group-hover:opacity-100
          transition-opacity
        "
        >
          Emojis
        </span>
      </button>

      {/* The Popup itself */}
      <Popup.Component placement="bottom-end">
        <PreviewEmojiContextProvider>
          <SelectEmojiProvider onChange={onChange}>
            <OverlayWindow size="w-80 max-w-xs" paddingSize="" border="">
              <EmojisListContainer />
              <EmojiPreview />
            </OverlayWindow>
          </SelectEmojiProvider>
        </PreviewEmojiContextProvider>
      </Popup.Component>
    </div>
  );
}
